import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { WCEmotionComponent } from './wc-emotion.component';
import { VivaToggleModule } from '../viva-toggle/viva-toggle.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    WCEmotionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    VivaToggleModule,
    TranslateModule
  ],
  exports: [
    WCEmotionComponent
  ]
})
export class  WCEmotionModule { }
